/**
 * Zweck: Beschreibt die TypeScript-Bausteine für den Frontend-Bereich frontend/src/app/components/domain-suggestions/app.domain-suggestions.component.ts.
 */
import {Component, OnInit} from '@angular/core';
import {AppConfigService} from '../../services/app.config.service';
import {DomainSuggestion} from '../../models/domain-suggestion';
import {
  AppDialogsDomainSuggestionsComponent
} from '../../dialogs/domain-suggestions/app.dialogs.domain-suggestions.component';
import {MatDialog} from '@angular/material/dialog';
import {AppLieferkundeService} from '../../services/app.lieferkunde.service';

/**
 * Zweck: Beschreibt class AppDomainSuggestionsComponent und ihren Daten- oder Funktionsvertrag.
 */
@Component({
    selector: 'domain-suggestions',
    templateUrl: 'app.domain-suggestions.component.html',
    styleUrls: ['app.domain-suggestions.component.scss'],
    standalone: false
})
export class AppDomainSuggestionsComponent implements OnInit {

  currentLKNr;

/**
 * Beschreibt Methode constructor und ihren Rückgabevertrag.
 */
  constructor(private lksvc: AppLieferkundeService, private cfg: AppConfigService, private dialog: MatDialog) {
  }


/**
 * Beschreibt Methode ngOnInit und ihren Rückgabevertrag.
 */
  ngOnInit(): void {
    this.lksvc.current_lieferkunde$.subscribe(lk => {
      if (lk) {
        if (!this.currentLKNr || this.currentLKNr != lk.LieferkundeNr) {
          this.currentLKNr = lk.LieferkundeNr;
          this.cfg.getDomainSuggestions().subscribe(suggs => {
            if (suggs && suggs.length > 0) {
              this.showSuggestions(suggs);
            }
          });
        }
      }
    });
  }

/**
 * Beschreibt Methode showSuggestions und ihren Rückgabevertrag.
 */
  showSuggestions(suggs: DomainSuggestion[]) {
    this.dialog.open(AppDialogsDomainSuggestionsComponent, {
      data: suggs,
      disableClose: true
    });
  }
}
